import { Routes } from '@/routes';

export default {
	'contract.index': () => import('./index'),
} as Routes;
